export interface PurgeCacheMessage {
  type: 'PURGE_CACHE';
}

export interface MessagesToServiceWorker {
  // Turn this into a union type as we add more events
  data: PurgeCacheMessage;
}

export const sendPurgeCacheMessage = () => {
  const message: PurgeCacheMessage = {
    type: 'PURGE_CACHE',
  };

  if (navigator.serviceWorker?.controller?.postMessage) {
    navigator.serviceWorker.controller.postMessage(message);
  }
};
